$(function() {

    // function screenClass() {
    //     if ($(window).innerWidth() > 1023) {
    //         // Create a clone of the navigation class called clone.
    //         $('.header').addClass('original').clone().insertAfter('.header').addClass('cloned').removeClass('original').hide();
            
    //         // Trigger the sticky function after you scroll down
    //         scrollIntervalID = setInterval(stickyTheMenu, 72);
    //     }
    // }
    
    // screenClass();
    
    // $(window).on('resize',function(){
    //     screenClass();
    // });
    
    // function stickyTheMenu() {
    //     var orgElementPos = $('.original').offset();
    //     if ($(".admin-bar")[0]) {
    //         orgElementTop = orgElementPos.top + 72;
    //     } else {
    //         orgElementTop = orgElementPos.top + 130;
    //         console.log('not admin bar');
    //     }
    
    //     // once you scroll past original, show the cloned class only
    //     if ($(window).scrollTop() >= (orgElementTop)) {
    //         console.log('yes')
    //         // Cloned element should always have same left position
    //         orgElement = $('.original');
    //         coordsOrgElement = orgElement.offset();
    //         leftOrgElement = coordsOrgElement.left;
    //         widthOrgElement = orgElement.css('width');
    //         $('.cloned').show().addClass('sticky');
    //         $('.original').css('visibility', 'hidden');
    //     } else {
    //         // not scrolled past the.main-navigation; only show the original.main-navigation.
    //         $('.cloned').hide().removeClass('sticky');;
    //         $('.original').css('visibility', 'visible');
    //     }
    // }

    $('.off-canvas-wrapper .mobile-menu').on('click', function() {
        $('body').addClass('shrink');
    });

    $('.js-off-canvas-overlay').on('click', function() {
        $('body').removeClass('shrink');
    });


    var page = window.location.pathname;
    if (page === '/retail/retail-form-2/' || 
    page === '/site-terms/' || 
    page === '/privacy-policy/' || 
    page === '/forgot-password/' || 
    page === '/register/' || 
    page === '/reset-password/' || 
    page === '/thank-you/') {
        $('#logged-out-nav').show();
        $('.sgw-images').show();
    }

    if (page === '/retail/sales-form/') {
        $('#logged-out-nav').show();
        $('.sgw-images.header-sgw-wrap ').hide();
    }


    // surgeon general warning image controls 
    var sgw = $('.sgw-images.header-sgw-wrap .header-sgw');
    var sgw2 = $('.sgw-images.in-page-sgw .header-sgw');
    var sgw3 = $('.sgw-images.mobile-header-sgw-wrap .header-sgw');
    var date  = new Date();
    var month = date.getMonth() + 1;

    if (month == 1 || month == 2 || month == 3) {
        $(sgw[0]).show();
        $(sgw2[0]).show();
        $(sgw3[0]).show();
    } else if (month == 4 || month == 5 || month == 6) {
        $(sgw[1]).show();
        $(sgw2[1]).show();
        $(sgw2[1]).show();
    } else if (month == 7 || month == 8 || month == 9) {
        $(sgw[2]).show();
        $(sgw2[2]).show();
        $(sgw2[2]).show();
    } else if (month == 10 || month == 11 || month == 12) {
        $(sgw[3]).show();
        $(sgw2[3]).show();
        $(sgw2[3]).show();
    }


    // single story read more click
    $('.modal-read-more').on('click', function() {
        var parent = $(this).parent();
        var name = parent.find('.modal-name').text();
        var info = parent.find('.modal-full-text').text();
        var popupName = $('.popup-modal-name');
        var popupInfo = $('.popup-modal-info');

        popupName.text(name);
        popupInfo.text(info);

        $('.modal-popup').addClass('show-modal');
    });

    $('.close-modal').on('click', function() {
        $('.modal-popup').removeClass('show-modal');
    });


    // retailers form submit
    $('.retailers-group form').on('submit', function() {
        $('.retailers-group').fadeOut(500, function() {
            $('.retail-thank-you').fadeIn(500);
        });
    });

    $('.retailers-group .close').on('click', function() {
        window.location = '/';
    });

});